export default __webpack_public_path__ + "static/media/ab_heart.19283cdb.svg";